"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CAMPAIGN_STATUS = void 0;
exports.CAMPAIGN_STATUS = {
    ACTIVE: 'ACTIVE',
    ARCHIVED: 'ARCHIVED',
    MIGRATING: 'MIGRATING'
};
//# sourceMappingURL=campaignStatus.js.map